/** Small dependency-free helpers shared across the app. */

/** Cryptographically-random lowercase-hex string of `bytes` bytes. */
export function randomHex(bytes = 16): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Stable-ish client id with a readable prefix, e.g. `ph_a1b2c3…`. */
export function uid(prefix: string): string {
  return `${prefix}_${randomHex(8)}`;
}

/** Promise that resolves after `ms` (used for mock latency + backoff). */
export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Clamp `n` into [min, max]. */
export function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}

/**
 * Parse a raw qty text-input value into a clamped integer, or null when the
 * input isn't a usable number (empty / NaN / "abc") — callers keep the previous
 * value on null. Decimals floor; values clamp into [min, max].
 */
export function parseQtyInput(raw: string, min = 1, max = 999): number | null {
  const n = Number.parseInt(raw.trim(), 10);
  if (!Number.isFinite(n)) return null;
  return clamp(Math.floor(n), min, max);
}
